import {AppConfig} from 'appConfig';
import {defaultsDeep} from 'lodash-es';
import {hardhat} from 'viem/chains';
import {SignUpFlow} from '../enums/sign-up-flow';
import goCiClientConfig from './go-ci-client';

const API_ROOT_HOST = 'dex.go.digital';

const appConfigPartial: Partial<AppConfig> = {
    env: 'dex-client',

    /**
     * @type {ApiConfig}
     */
    api: {
        root: `https://${API_ROOT_HOST}/client-frontend`,

        transactions: 'api/v1/transactions',
        positionFrames: 'api/v1/position-frame/history',
        dexOrders: 'api/v1/orders',
        dexOrderTransactions: 'api/v1/order-transactions',
        dexStreaming: 'api/v2/stream'
    },

    localStorageKeyPrefix: 'dex/v1/client',

    isSmartSecurityEnabled: false,

    signUpFlow: SignUpFlow.CLOSED,
    signUpEmailAsUsername: true,
    signUpInstantAccess: false,
    signUpWithoutApproval: true,
    signUpDisplayReferralIdInput: true,
    signUpOnboardingProcessSupport: true,

    resetPasswordFlow: true,

    signUpUrl: null, // Clear to use the internal sign-up URL.

    logoImageUrl:           'images/cplx-logo.svg',
    backofficeLogoImageUrl: 'images/cplx-logo.svg',
    loginLogoImageUrl:      'images/cplx-full-logo.svg',

    // [HED-930] Securities settings for DEX
    displayExchange: false,
    exchangesAllowedInAccount: [
        'KRAKEN_FUT'
    ],
    defaultSecurityKey: 'BTCUSD.P:KRAKEN_FUT:USD',
    doFetchWatchlistsOnInit: false,

    simulatorAppConfig: null,

    isGuestDashboardEnabled: true,
    isLoggerApiEnabled: true,

    dynamicXyz: {
        environmentId: 'f893c5a2-1112-47f9-a9ec-c552bbdfcf25',
        testNetwork: {
            isTestnet: true,
            blockExplorerUrls: [],
            chainId: hardhat.id,
            networkId: hardhat.id,
            name: 'DEX',
            iconUrls: ['https://dex.go.digital/favicon.svg'],
            nativeCurrency: {
                decimals: 18,
                name: 'Ether',
                symbol: 'ETH',
                iconUrl: 'https://app.dynamic.xyz/assets/networks/eth.svg'
            },
            rpcUrls: [`https://${API_ROOT_HOST}/api/dex`]
        },
        singleNetworkId: hardhat.id
    },
    dex: {
        dexContractAddress: '0x712516e61C8B383dF4A63CFe83d7701Bce54B03e',
        chain: {
            ...hardhat,
            testnet: true,
            name: 'DEX',
            rpcUrls: {
                default: {
                    http: [`https://${API_ROOT_HOST}/api/dex`],
                    webSocket: [`wss://${API_ROOT_HOST}/api/dex`]
                }
            }
        }
    },

    dashboardMinVersion: '1.0.2'
};

export const dexClientConfig: AppConfig = defaultsDeep(appConfigPartial, goCiClientConfig);
export default dexClientConfig;
